import Urplan from './urplan';

const instances = [];

export function init(url, selector) {
    const instance = new Urplan(url, selector);
    instances.push(instance);
    return instance;
}